import React from "react";
import "../../Style/Contact.scss";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import image1 from "../../Assets/Images/Contact/image1.png";
import image2 from "../../Assets/Images/Contact/image2.png";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useEffect } from "react";
import cld from "../../config/cloudcf";
import { AdvancedImage } from "@cloudinary/react";
import maps from "../../Assets/Images/Contact/maps.png";
import emailjs from "@emailjs/browser";
import Masonry from "react-masonry-css";

function Contact() {
  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {
    gsap.from(".Line", {
      width: 0,
    });
    gsap.to(".Line", {
      scrollTrigger: {
        trigger: ".Line",
      },
      width: "100%",
      duration: 2,
    });
  });
  const Contact1 = cld.image("rbn/contact/contact_2_up");
  const Contact2 = cld.image("rbn/contact/contact_2");

  const sendEmail = (e) => {
    e.preventDefault();
    alert("Submited");

    emailjs.sendForm(
      "service_44uul7x",
      "template_qwieyku",
      e.target,
      "Qaa3M9NKE5orwtySZ"
    );
  };
  const breakpointColumnsObj = {
    default: 3,
    1100: 2,
    700: 4,
  };

  const items = [
    {
      type: "image",
      url: "https://res.cloudinary.com/doy2qixs5/image/upload/v1745569352/rbn/technology/modform-1_tsuotc.jpg",
    },
    {
      type: "image",
      url: "https://res.cloudinary.com/doy2qixs5/image/upload/v1745569352/rbn/technology/modform-3_fvnnbh.jpg",
    },
    { type: "color" },
    { type: "color" },

    {
      type: "image",
      url: "https://res.cloudinary.com/doy2qixs5/image/upload/v1745569352/rbn/technology/modfrom-2_jksjef.jpg",
    },
    {
      type: "image",
      url: "https://res.cloudinary.com/doy2qixs5/image/upload/v1745636543/rbn/technology/modfac_kaffik.jpg",
    },
    {
      type: "image",
      url: "https://res.cloudinary.com/doy2qixs5/image/upload/v1745636538/rbn/technology/mod_xj263e.jpg",
    },
    { type: "color" },
    {
      type: "image",
      url: "https://res.cloudinary.com/doy2qixs5/image/upload/v1745636539/rbn/technology/modmod_uknqwx.jpg",
    },
    {
      type: "image",
      url: "https://res.cloudinary.com/doy2qixs5/image/upload/v1745636539/rbn/technology/modlite_pup7us.jpg",
    },
  ];

  return (
    <div className="Contact-Container">
      <div className="Section-1" id="ourfactory">
        <div className="Contact-Title">
          <h1>Our Factory</h1>
          <div className="Line-Box">
            <span className="Line" />
          </div>
        </div>
        <div className="Image-Container">
          <img
            src={
              "https://res.cloudinary.com/doy2qixs5/image/upload/v1745636690/rbn/technology/port-klang-factory_d5tlnc.jpg"
            }
            className="img"
            alt="Our Factory"
          />
          <div className="Text-Block">Located in Port Klang, Malaysia.</div>
        </div>
      </div>
      <div className="Section-2" id="wwo">
        {/* Title */}
        <div className="Title-Wrapper">
          <h1>What We Offer</h1>
          <div className="Line-Box">
            <div className="Line" />
          </div>
        </div>

        {/* Embedded video with floating label */}
        <div className="Video-Container">
          <div className="Video-Wrapper">
          <video
            src="https://res.cloudinary.com/doy2qixs5/video/upload/v1745833488/rbn/technology/video/modform-technology-video_ddwswp.mp4"
            title="ModForm™: Swift Execution. Exact Results."
            autoPlay
            loop
            controls
            muted
            playsInline
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "6px",
              objectFit: "cover",
            }}
          />
          </div>
        </div>

        {/* Description */}
        <div className="Text-Wrapper">
          <h3>
            <strong>ModForm™: Swift Execution. Exact Results.</strong>
          </h3>
          <p>
            Our modform™ wall system is a load bearing modular formwork
            construction system for building high rise buildings, a game changer
            for the construction industry. Not only enables solid building
            structures to be completed extremely fast compared to conventional
            construction methods, our system requiring less energy consumption,
            saving up more energy bills.
          </p>
        </div>
        {/* <div className="Maps-Container">
          <div className="Maps-Detail">
            <span className="Maps-Title">Where to Find Us</span>
            <p className="Maps-Desc">
              Menara Batavia 30th Floor Jl. K.H. Mas Mansyur, Kav. 126 Jakarta
              10250 Indonesia
              <span>Phone. : (021) 572 2470</span>
              <span> (Hunting) Fax : (021) 572 2472</span>
            </p>
            <button className="Button-Container-Desktop">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/Menara+Batavia+Building+Management/@-6.2107062,106.8133399,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69f6aa0ce995f9:0xed935b94a739c157!8m2!3d-6.2107062!4d106.8155286!16s%2Fm%2F0wfj_1v"
              >
                View Maps
              </a>
            </button>
          </div>
          <div className="Maps">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2764.460180111871!2d106.8153073854185!3d-6.210519312998017!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f6aa0ce995f9%3A0xed935b94a739c157!2sMenara%20Batavia%20Building%20Management!5e0!3m2!1sen!2sid!4v1680674304872!5m2!1sen!2sid"
              style={{ border: 0, width: "100%", height: "100%" }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
            <div className="Button-Container-Mobile">
              <button>
                <a
                  target="_blank"
                  href="https://www.google.com/maps/place/Menara+Batavia+Building+Management/@-6.2107062,106.8133399,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69f6aa0ce995f9:0xed935b94a739c157!8m2!3d-6.2107062!4d106.8155286!16s%2Fm%2F0wfj_1v"
                >
                  View Maps
                </a>
              </button>
            </div>
          </div>
        </div> */}
      </div>
      <div className="Section-4">
        <div className="Video-Wrapper">
          <video
            src="https://res.cloudinary.com/doy2qixs5/video/upload/v1745833478/rbn/technology/video/net-zero-flying-factory-video_hkax8n.mp4"
            title="Net Zero Modform Flying Factory"
            autoPlay
            loop
            muted
            controls
            playsInline
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "6px",
              objectFit: "cover",
            }}
          />
        </div>

        <div className="Video-Text">
          <h3>
            <strong>Net Zero Modform™ Flying Factory</strong>
          </h3>
          <p>
            Flying Factory is a capital light, easy to deploy factory to enable
            rapid expansion capabilities. Our flying factory technology enables
            us to build and deploy homes with more mobility, flexibility, time &
            cost savings.
          </p>
        </div>
      </div>
      <div className="Section-3">
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {items.map((item, index) => (
            <div key={index} className="Masonry-Item">
              {item.type === "image" ? (
                <img src={item.url} alt={`Gallery ${index}`} loading="lazy" />
              ) : (
                <div className="Yellow-Block"></div>
              )}
            </div>
          ))}
        </Masonry>
      </div>
    </div>
  );
}

export default Contact;
